import {ChangeDetectionStrategy, Component, computed, inject, input, InputSignal, Signal} from "@angular/core";
import {MenuDietaryIndicatorsData, MenuSellableData} from '../../../menu/menu-entity.model';
import {ThemeModel} from '../../../theme/theme.model';
import {NgClass} from '@angular/common';
import {TouchableDirective} from '../../../ui-elements/touchable.directive';
import {MenuModel} from '../../../menu/menu.model';

@Component({
    selector: "woa-dietary-panel",
    templateUrl: "./dietary-panel.component.html",
    styleUrl: "./dietary-panel.component.scss",
    host: {
        "[class.empty]": "isEmpty()"
    },
    imports: [
        NgClass,
        TouchableDirective
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DietaryPanelComponent {
    public themeModel: ThemeModel = inject(ThemeModel);
    public menuModel: MenuModel = inject(MenuModel);

    public readonly sellable: InputSignal<MenuSellableData> = input.required<MenuSellableData>();

    public readonly showKilojoules: InputSignal<boolean> = input<boolean>(true);

    public isEmpty: Signal<boolean> = computed(() => !(this.showKilojoules() && this.sellable().kiloJoules) && !(this.menuModel.currentMenu() && this.sellable().dietaryIndicators.length));

    getDisplayedIndicatorCode(indicator: MenuDietaryIndicatorsData): string {
        return indicator.code.substring(0, 3);
    }

    tooltipLeft(icon: HTMLElement, label: HTMLElement): boolean {
        return (window.innerWidth - icon.getBoundingClientRect().right) < label.getBoundingClientRect().width + 5;
    }
}
